<template>
    <v-card flat class="">
        <v-alert v-if="data.flag_end == '1'" dense shaped type="error">Non Aktif</v-alert>
        <judul-praktik :data="data"></judul-praktik>
        <div class="mt-2 mx-2 pb-2" v-if="user.role == 'ADMIN'">
            <evaluasi-button :data="data" :praktik_id="praktik_id"></evaluasi-button>
        </div>
        <v-card-title v-if="data.flag_end == '0'" primary-title>
            <h4>Evaluasi Peserta Didik</h4>
            <v-spacer></v-spacer>
            <v-select v-model="table.pembimbing" outlined hide-details dense label="Pembimbing :"
                :items="table.pembimbings" @change="getDataFromApi()" item-value="user_id" item-text="nama"></v-select>
        </v-card-title>
        <v-simple-table v-if="data.flag_end == '0'" dense bord>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th rowspan="2" class="text-center">No</th>
                        <th rowspan="2" class="text-center">Nama</th>
                        <th rowspan="2" class="text-center">Keterampilan</th>
                        <th rowspan="2" class="text-center">Tugas</th>
                        <th rowspan="2" class="text-center">BST</th>
                        <th rowspan="2" class="text-center">DOPS</th>
                        <th rowspan="2" class="text-center">Ref./Jur. Reading</th>
                        <th rowspan="2" class="text-center">Mini CEX</th>
                        <th rowspan="2" class="text-center">CBD</th>
                        <th rowspan="2" class="text-center">Lap. Jaga</th>
                        <th rowspan="2" class="text-center">Catatan</th>
                        <th rowspan="2" v-if="user.role != 'ADMIN'">&nbsp;</th>
                        <th colspan="3" class="text-center">Jaminan Mutu</th>
                        <th rowspan="2">Verifikasi</th>
                    </tr>
                    <tr>
                        <th class="text-center">Form Kepatuhan APD</th>
                        <th class="text-center">Form Kepatuhan Kebersihan Tangan</th>
                        <th class="text-center">Form SKP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, idx) in table.items" :key="item.id">
                        <td>{{ idx + 1 }}</td>
                        <td>{{ item.nama }}</td>
                        <td class="text-center">{{ item.keterampilan }}</td>
                        <td class="text-center">{{ item.tugas }}</td>
                        <td class="text-center">{{ item.bst }}</td>
                        <td class="text-center">{{ item.dops }}</td>
                        <td class="text-center">{{ item.referat }}</td>
                        <td class="text-center">{{ item.mini_cex }}</td>
                        <td class="text-center">{{ item.cbd }}</td>
                        <td class="text-center">{{ item.laporan_jaga }}</td>
                        <td>
                            <v-textarea :value="item.catatan" readonly dense outlined hide-details></v-textarea>
                        </td>
                        <td v-if="user.role != 'ADMIN'">
                            <v-btn color="success" x-small @click="editItem(item)">
                                <v-icon x-small>
                                    {{ icons.mdiPencil }}
                                </v-icon>
                            </v-btn>
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.evaluasi_nmutu_apd_id !== null" color="success">
                                {{ icons.mdiCheckCircle }}
                            </v-icon>
                            <v-btn color="primary" x-small @click="editApd(item, item.evaluasi_nmutu_apd_id)">
                                <v-icon v-if="user.role != 'ADMIN'" x-small>
                                    {{ icons.mdiPencil }}
                                </v-icon>
                                <v-icon v-else x-small>
                                    {{ icons.mdiEye }}
                                </v-icon>
                            </v-btn>
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.evaluasi_nmutu_tangan_id !== null" color="success">
                                {{ icons.mdiCheckCircle }}
                            </v-icon>
                            <v-btn color="primary" x-small @click="editTangan(item, item.evaluasi_nmutu_tangan_id)">
                                <v-icon v-if="user.role != 'ADMIN'" x-small>
                                    {{ icons.mdiPencil }}
                                </v-icon>
                                <v-icon v-else x-small>
                                    {{ icons.mdiEye }}
                                </v-icon>
                            </v-btn>
                        </td>
                        <td class="text-center">
                            <v-icon v-if="item.evaluasi_nmutu_keselamatan_id !== null" color="success">
                                {{ icons.mdiCheckCircle }}
                            </v-icon>
                            <v-btn color="primary" x-small
                                @click="editKeselamatan(item, item.evaluasi_nmutu_keselamatan_id)">
                                <v-icon v-if="user.role != 'ADMIN'" x-small>
                                    {{ icons.mdiPencil }}
                                </v-icon>
                                <v-icon v-else x-small>
                                    {{ icons.mdiEye }}
                                </v-icon>
                            </v-btn>
                        </td>
                        <td>
                            <div v-if="item.verified_at == null">
                                <v-checkbox v-model="form.editedItem.ids" x-small :value="item.id" dense
                                    hide-details=""></v-checkbox>
                            </div>
                            <div v-else>
                                <v-chip color="secondary" x-small>Verif: {{ formatDateTime(item.verified_at) }}</v-chip>
                                <v-checkbox v-model="form.editedItem.ids" x-small :value="item.id" dense
                                    hide-details=""></v-checkbox>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <td colspan="14"></td>
                    <td class="text-left"><v-btn color="primary" class="mr-2" x-small
                            @click="verifikasiNilaiSelected()">Simpan Verifikasi</v-btn>
                        <v-btn color="error" x-small @click="batalVerifikasiNilaiSelected()">Batal Verifikasi</v-btn>
                    </td>
                </tfoot>
            </template>
        </v-simple-table>
        <v-dialog v-model="dialog" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h6">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.editedItem.keterampilan" type="number" outlined dense
                                hide-details label="Keterampilan :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.editedItem.tugas" type="number" outlined dense hide-details
                                label="Tugas :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.bst" type="number" outlined dense hide-details
                                label="BST :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.dops" type="number" outlined dense hide-details
                                label="DOPS :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.referat" type="number" outlined dense hide-details
                                label="Referat/Jurnal Reading :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.mini_cex" type="number" outlined dense hide-details
                                label="Mini CEX :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.cbd" type="number" outlined dense hide-details
                                label="CBD :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="form.editedItem.laporan_jaga" type="number" outlined dense
                                hide-details label="Laporan Jaga :"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea label="Catatan :" v-model="form.editedItem.catatan" dense outlined
                                hide-details></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions v-if="user.role != 'ADMIN'">
                    <v-btn color="primary" @click="save()" v-if="form.editedItem.verified_at == null">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogApd" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h6">Penilaian Jaminan Mutu Kepatuhan APD</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.apd.tanggal" type="date" outlined dense hide-details
                                label="Tanggal Penilaian:"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.apd.jenis_tindakan" outlined dense hide-details
                                label="Jenis Tindakan :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.apd.jenis_apd" outlined dense hide-details
                                label="Jenis APD :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <label for="">Kepatuhan peserta didik:</label>
                            <v-radio-group v-model="form.apd.kepatuhan" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions v-if="user.role != 'ADMIN'">
                    <v-btn color="primary" @click="saveApd()" v-if="form.editedItem.verified_at == null">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogTangan" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h6">Penilaian Jaminan Mutu Kebersihan Tangan</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-autocomplete v-model="form.tangan.ruang_id" :items="form.ruangs" outlined dense
                                label="Ruang :" item-text="nama" item-value="id" hide-details=""></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.tanggal_praktek" type="date" outlined dense hide-details
                                label="Tanggal Praktek:"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.sebelum_kontak" type="number" outlined dense hide-details
                                label="Sebelum Kontak dengan pasien :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.sebelum_tindakan" type="number" outlined dense
                                hide-details label="Sebelum Tindakan aseptic :"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.setelah_terkena" type="number" outlined dense
                                hide-details label="Setelah terkena cairan tubuh pasien :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.setelah_kontak" type="number" outlined dense hide-details
                                label="Setelah kontak dengan pasien  :"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.tangan.setelah_kontak_lingkungan" type="number" outlined dense
                                hide-details label="Setelah kontak dengan lingkungan pasien  :"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions v-if="user.role != 'ADMIN'">
                    <v-btn color="primary" @click="saveTangan()" v-if="form.editedItem.verified_at == null">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogKeselamatan" max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="text-h6">Penilaian Jaminan Mutu Sasaran Keselamatan Pasien</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-autocomplete v-model="form.keselamatan.ruang_id" :items="form.ruangs" outlined dense
                                label="Ruang :" item-text="nama" item-value="id" hide-details=""></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field v-model="form.keselamatan.tanggal_praktek" type="date" outlined dense
                                hide-details label="Tanggal Praktek:"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.identifikasi" type="number" outlined dense
                                hide-details label="Mengidentifikasi pasien dengan benar :"></v-text-field> -->
                            <label for="">Mengidentifikasi pasien dengan benar:</label>
                            <v-radio-group v-model="form.keselamatan.identifikasi" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.komunikasi" type="number" outlined dense
                                hide-details label="Meningkatkan komunikasi efektif :"></v-text-field> -->
                            <label for="">Meningkatkan komunikasi efektif:</label>
                            <v-radio-group v-model="form.keselamatan.komunikasi" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.keamanan_obat" type="number" outlined dense
                                hide-details
                                label="Meningkatkan keamanan obat-oabatan yang harus diwaspadai :"></v-text-field> -->
                            <label for="">Meningkatkan keamanan obat-oabatan yang harus diwaspadai:</label>
                            <v-radio-group v-model="form.keselamatan.keamanan_obat" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.prosedur" type="number" outlined dense hide-details
                                label="Memastikan sisi yang benar dan prosedur yang benar  :"></v-text-field> -->
                            <label for="">Memastikan sisi yang benar dan prosedur yang benar:</label>
                            <v-radio-group v-model="form.keselamatan.prosedur" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.resiko_infeksi" type="number" outlined dense
                                hide-details label="Mengurangi resiko infeksi akibat perawatan :"></v-text-field> -->
                            <label for="">Mengurangi resiko infeksi akibat perawatan:</label>
                            <v-radio-group v-model="form.keselamatan.resiko_infeksi" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <!-- <v-text-field v-model="form.keselamatan.resiko_ciderapasien" type="number" outlined dense
                                hide-details label="Mengurangi resiko ciderapasien akibat jatuh :"></v-text-field> -->
                            <label for="">Mengurangi resiko ciderapasien akibat jatuh:</label>
                            <v-radio-group v-model="form.keselamatan.resiko_ciderapasien" row>
                                <v-radio label="Ya" value="Ya"></v-radio>
                                <v-radio label="Tidak" value="Tidak"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions v-if="user.role != 'ADMIN'">
                    <v-btn color="primary" @click="saveKeselamatan()" v-if="form.editedItem.verified_at == null">
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import JudulPraktik from '@/components/JudulPraktik.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import { mdiCheckCircle, mdiDelete, mdiPencil, mdiSend, mdiFileCancel, mdiEye } from '@mdi/js'
import EvaluasiButton from '@/components/EvaluasiButton.vue'
export default {
    components: {
        JudulPraktik, EvaluasiButton
    },
    data() {
        return {
            praktik_id: this.$route.params.praktik_id,
            data: {
                nama_institusi: '',
                nama_prodi: '',
                profesi: '',
                stase: '',
                tanggal_awal: '',
                tanggal_akhir: '',
            },
            icons: {
                mdiDelete,
                mdiPencil,
                mdiCheckCircle, mdiSend, mdiFileCancel, mdiEye
            },
            tableOptions: {},
            table: {
                loading: true,
                items: [],
                totalItems: 0,
                pembimbing: '',
                pembimbings: [],
            },
            dialog: false,
            dialogApd: false,
            dialogTangan: false,
            dialogKeselamatan: false,
            form: {
                editedIndex: -1,
                editedItem: {
                    id: '',
                    praktik_id: '',
                    user_id: '',
                    bst: '',
                    dops: '',
                    referat: '',
                    mini_cex: '',
                    cbd: '',
                    laporan_jaga: '',
                    catatan: '',
                    keterampilan: 0,
                    tugas: 0,
                    ids: [],
                },
                defaultItem: {
                    id: '',
                    praktik_id: '',
                    user_id: '',
                    bst: '',
                    dops: '',
                    referat: '',
                    mini_cex: '',
                    cbd: '',
                    catatan: '',
                    keterampilan: 0,
                    tugas: 0,
                    ids: [],
                },
                pembimbings: [],
                apd: {
                    id: '',
                    praktik_id: '',
                    user_id: '',
                    tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                    jenis_tindakan: '',
                    jenis_apd: '',
                    kepatuhan: '',
                },
                tangan: {
                    id: '',
                    praktik_id: '',
                    user_id: '',
                    ruang_id: '',
                    tanggal_praktek: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                    sebelum_kontak: '',
                    sebelum_tindakan: '',
                    setelah_terkena: '',
                    setelah_kontak: '',
                    setelah_kontak_lingkungan: '',
                },
                keselamatan: {
                    id: '',
                    praktik_id: '',
                    user_id: '',
                    ruang_id: '',
                    tanggal_praktek: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                    identifikasi: '',
                    komunikasi: '',
                    keamanan_obat: '',
                    prosedur: '',
                    resiko_infeksi: '',
                    resiko_ciderapasien: '',
                },
            },
        }
    },
    computed: {
        formTitle() {
            return this.form.editedIndex === -1 ? 'Tambah Data' : 'Edit Data'
        },
        user() {
            return this.$store.getters.user
        },
    },
    created() {
        this.getDetail()
        this.getsPembimbing()
        this.getRuangs()
    },
    methods: {
        getsPembimbing() {
            const fmData = new FormData()
            fmData.append('praktik_id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPembimbingPraktik', fmData)
                .then(response => {
                    this.table.pembimbings = response.data
                })
                .catch(error => {
                    alert(error)
                })
        },
        save() {
            const fmData = new FormData()
            fmData.append('id', this.form.editedItem.id)
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('user_id', this.form.editedItem.user_id)
            fmData.append('bst', this.form.editedItem.bst)
            fmData.append('dops', this.form.editedItem.dops)
            fmData.append('referat', this.form.editedItem.referat)
            fmData.append('mini_cex', this.form.editedItem.mini_cex)
            fmData.append('cbd', this.form.editedItem.cbd)
            fmData.append('laporan_jaga', this.form.editedItem.laporan_jaga)
            fmData.append('catatan', this.form.editedItem.catatan)
            fmData.append('keterampilan', this.form.editedItem.keterampilan)
            fmData.append('tugas', this.form.editedItem.tugas)
            axiosPostAuth('api/Pembimbing/saveEvaluasiDokter', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.getDataFromApi()
                        this.dialog = false
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        getDataFromApi() {
            const fmData = new FormData()
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('pembimbing_id', this.table.pembimbing)
            axiosPostAuth('api/Penilaian/getEvaluasiDokterByPembimbingId', fmData)
                .then(response => {
                    this.table.items = response.data
                    this.table.totalItems = response.total
                    this.table.loading = false
                })
                .catch(error => {
                    alert(error)
                })
        },
        add() {
            this.form.editedItem = Object.assign({}, this.form.defaultItem)
            this.form.editedIndex = -1
        },
        editItem(item) {
            this.form.editedIndex = this.table.items.indexOf(item)
            this.form.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        getDetail() {
            const fmData = new FormData()
            fmData.append('id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPraktik', fmData)
                .then(response => {
                    this.data = Object.assign({}, response.data)
                })
                .catch(error => {
                    alert(error)
                })
        },

        editApd(item) {
            this.form.editedItem = Object.assign({}, item)
            if (item.evaluasi_nmutu_apd_id !== null) {
                this.getApd(item.evaluasi_nmutu_apd_id)
            } else {
                this.dialogApd = true
            }
        },
        getApd(id) {
            const fmData = new FormData()
            fmData.append('id', id)
            axiosPostAuth('api/Penilaian/getMutuApd', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.form.apd = Object.assign({}, response.data)
                        this.dialogApd = true
                    }
                    else {
                        // alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        saveApd() {
            const fmData = new FormData()
            // fmData.append('id', this.form.apd.id)
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('user_id', this.form.editedItem.user_id)
            fmData.append('tanggal', this.form.apd.tanggal)
            fmData.append('jenis_tindakan', this.form.apd.jenis_tindakan)
            fmData.append('jenis_apd', this.form.apd.jenis_apd)
            fmData.append('kepatuhan', this.form.apd.kepatuhan)
            axiosPostAuth('api/Penilaian/saveMutuApd', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.getDataFromApi()
                        this.dialogApd = false
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },

        editTangan(item) {
            this.form.editedItem = Object.assign({}, item)
            if (item.evaluasi_nmutu_tangan_id !== null) {
                this.getTangan(item.evaluasi_nmutu_tangan_id)
            } else {
                this.dialogTangan = true
            }
        },
        getTangan(id) {
            const fmData = new FormData()
            fmData.append('id', id)
            axiosPostAuth('api/Penilaian/getMutuTangan', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.form.tangan = Object.assign({}, response.data)
                        this.dialogTangan = true
                    }
                    else {
                        // alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        getRuangs() {
            axiosGetAuth('api/Penilaian/getRuangs')
                .then(response => {
                    this.form.ruangs = response.data
                })
                .catch(error => {
                    alert(error)
                })
        },
        saveTangan() {
            const fmData = new FormData()
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('user_id', this.form.editedItem.user_id)
            fmData.append('ruang_id', this.form.tangan.ruang_id)
            fmData.append('tanggal_praktek', this.form.tangan.tanggal_praktek)
            fmData.append('sebelum_kontak', this.form.tangan.sebelum_kontak)
            fmData.append('sebelum_tindakan', this.form.tangan.sebelum_tindakan)
            fmData.append('setelah_terkena', this.form.tangan.setelah_terkena)
            fmData.append('setelah_kontak', this.form.tangan.setelah_kontak)
            fmData.append('setelah_kontak_lingkungan', this.form.tangan.setelah_kontak_lingkungan)
            axiosPostAuth('api/Penilaian/saveMutuTangan', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.getDataFromApi()
                        this.dialogTangan = false
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },

        editKeselamatan(item) {
            this.form.editedItem = Object.assign({}, item)
            if (item.evaluasi_nmutu_keselamatan_id !== null) {
                this.getKeselamatan(item.evaluasi_nmutu_keselamatan_id)
            } else {
                this.dialogKeselamatan = true
            }
        },
        getKeselamatan(id) {
            const fmData = new FormData()
            fmData.append('id', id)
            axiosPostAuth('api/Penilaian/getMutuKeselamatan', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.form.keselamatan = Object.assign({}, response.data)
                        this.dialogKeselamatan = true
                    }
                    else {
                        // alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        saveKeselamatan() {
            const fmData = new FormData()
            // fmData.append('id', this.form.apd.id)
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('user_id', this.form.editedItem.user_id)
            fmData.append('ruang_id', this.form.keselamatan.ruang_id)
            fmData.append('tanggal_praktek', this.form.keselamatan.tanggal_praktek)
            fmData.append('identifikasi', this.form.keselamatan.identifikasi)
            fmData.append('komunikasi', this.form.keselamatan.komunikasi)
            fmData.append('keamanan_obat', this.form.keselamatan.keamanan_obat)
            fmData.append('prosedur', this.form.keselamatan.prosedur)
            fmData.append('resiko_infeksi', this.form.keselamatan.resiko_infeksi)
            fmData.append('resiko_ciderapasien', this.form.keselamatan.resiko_ciderapasien)
            axiosPostAuth('api/Penilaian/saveMutuKeselamatan', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.getDataFromApi()
                        this.dialogKeselamatan = false
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },


        verifikasiNilaiSelected(item) {
            const fmData = new FormData()
            fmData.append('ids', this.form.editedItem.ids)
            fmData.append('kategori', 'Dokter')
            axiosPostAuth('api/Penilaian/verifikasiNilai', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.$notify({
                            type: 'success',
                            title: 'Berhasil',
                            text: response.message,
                        });
                        this.form.editedItem.ids = []
                        this.getDataFromApi()
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        batalVerifikasiNilaiSelected(item) {
            let r = confirm('Yakin batal verifikasi nilai?')
            if (!r) return

            const fmData = new FormData()
            fmData.append('ids', this.form.editedItem.ids)
            fmData.append('kategori', 'Dokter')
            axiosPostAuth('api/Penilaian/batalVerifikasiNilai', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.$notify({
                            type: 'success',
                            title: 'Berhasil',
                            text: response.message,
                        });
                        this.form.editedItem.ids = []
                        this.getDataFromApi()
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
    },
}
</script>